export default "__VITE_IMAGE_ASSET__31628907__";